import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";

// Vite's base is "/" because the portal owns the whole domain. Keep
// the basename-aware pattern in case we ever sub-path it later.
const ROUTER_BASENAME =
  (import.meta.env.BASE_URL || "/").replace(/\/+$/, "") || "/";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter basename={ROUTER_BASENAME}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
